module.exports = __webpack_public_path__ + "img/articles_201795.801652c0.png";